<template>
  <div class="code-box">
    <div class="text">{{ $lang('为了保护客户的隐私安全，请输入快递预留的收/寄件人联系方式的后四位进行验证') }}</div>
    <div class="captcha">
      <div :class="[index <= cIndex ? 'active-input' : '', 'input-div']" v-for="(c, index) in ct" :key="index">
        <input
          type="tel"
          v-model="ct[index]"
          ref="input"
          @input="
            (e) => {
              onInput(e.target.value, index)
            }
          "
          @keydown.delete="
            (e) => {
              onKeydown(e.target.value, index)
            }
          "
          @focus="onFocus"
          :disabled="loading"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    focusIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ct: ['', '', '', ''],
      loading: false,
      msg: '',
      dialog: false
    }
  },
  computed: {
    ctSize() {
      return this.ct.length
    },
    cIndex() {
      let i = this.ct.findIndex((item) => item === '')
      i = (i + this.ctSize) % this.ctSize
      return i
    },
    lastCode() {
      return this.ct[this.ctSize - 1]
    }
  },
  watch: {
    cIndex() {
      this.resetCaret()
    },
    lastCode(val) {
      if (val) {
        this.$refs.input[this.ctSize - 1].blur()
        this.sendCaptcha()
      }
    }
  },
  mounted() {
    this.resetCaret()
  },
  methods: {
    hideDiaLog() {
      this.reset()
      this.dialog = false
    },
    showDialog() {
      // this.reset()
      this.dialog = true
      this.loading = false
      this.$nextTick((_) => {
        this.$refs.input[0].focus()
      })
      // this.resetCaret()
    },
    onInput(val, index) {
      this.msg = ''
      val = val.replace(/\s/g, '')
      if (index === this.ctSize - 1) {
        this.ct[this.ctSize - 1] = val[0] // 最后一个码，只允许输入一个字符。
      } else if (val.length > 1) {
        let i = index
        for (i = index; i < this.ctSize && i - index < val.length; i++) {
          this.ct[i] = val[i]
        }
        this.resetCaret()
      }
    },
    // 重置光标位置。
    resetCaret() {
      this.$nextTick(() => {
        // this.$refs.input[this.ctSize - 1].focus()
        if (this.$refs.input && this.$refs.input.length) this.$refs.input[this.ctSize - 1].focus()
      })
    },
    onFocus() {
      // 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
      let index = this.ct.findIndex((item) => item === '')
      index = (index + this.ctSize) % this.ctSize
      this.$refs.input[index].focus()
    },
    onKeydown(val, index) {
      if (val === '') {
        // 删除上一个input里的值，并对其focus。
        if (index > 0) {
          this.ct[index - 1] = ''
          this.$refs.input[index - 1].focus()
        }
      }
    },
    async sendCaptcha() {
      const phone = this.ct.join('')
      this.loading = true
      this.$emit('sendCaptcha', phone, this.focusIndex, (cb, msg) => {
        if ((cb, msg)) {
          this.msg = msg
          this.loading = false
          this.$nextTick(() => {
            this.reset()
          })
        }
      })
    },

    reset() {
      // 重置。一般是验证码错误时触发。
      this.ct = this.ct.map((item) => '')
      this.resetCaret()
      this.showDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
.code-box {
  width: 100%;
  height: 200px;
  background: #f8f8f8;
  display: flex;
  align-content: center;
  flex-direction: column;

  .text {
    max-width: 780px;
    margin: 30px auto 0;
    font-size: 16px;
    font-weight: 400;
    color: #2b2b2b;
    line-height: 20px;
    text-align: center;
  }
}
.captcha {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 40px;
  ::v-deep .q-field {
    margin: 0 20px;
  }
}
.input-div {
  position: relative;
  margin: 0 10px;

  // &::after {
  //   position: absolute;
  //   content: '';
  //   width: 64px;
  //   height: 1px;
  //   left: 0;
  //   bottom: 0;
  //   background: #eee;
  // }
  // &.active-input {
  //   &::after {
  //     background: #333;
  //   }
  // }
}
input {
  // margin-right: 20px;
  position: relative;
  width: 64px;
  height: 100px;
  border-radius: 8px;
  text-align: center;
  outline-style: none;
  outline-width: 0px;
  // border: none;
  border-style: none;
  text-shadow: none;
  font-size: 28px;
  outline: none;
  background: none;
  box-shadow: none;
  border-radius: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  box-shadow: none; /*去除阴影*/
  outline: medium; /*聚焦input的蓝色边框*/
  resize: none; /*textarea 禁止拖拽*/
  appearance: none;
  -webkit-appearance: none; /*常用于IOS下移除原生样式*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*点击高亮的颜色*/
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
  border: 1px solid rgba(0,0,0,0.24);
  // border-bottom: 1px solid #eee;
  // &::before {
  //   position: absolute;
  //   content: '';
  //   width: 100px;
  //   height: 1px;
  //   background: #eee;
  // }
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 100px white inset;
}
input:last-of-type {
  margin-right: 0;
}
input:disabled {
  color: #000;
  // background-color: #fff;
}
.msg {
  text-align: center;
}
</style>
